export const environment = {
  production: true,
  apiUrl: 'https://api-redux.usebenchmark.com'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts